<ng-container *ngIf="searchStatus$ | async as status">
  @if(status === 'idle') {
  <app-address-search-field
    [formControl]="adddressSearch"
  ></app-address-search-field>
  } @else {
  <p>Getting full address</p>
  }
</ng-container>
